import React from 'react'
import Typography from '@mui/material/Typography'
import Stack, { StackProps } from '@mui/material/Stack'
import Box from '@mui/material/Box'

interface Props extends StackProps {
  data: (React.ReactNode[] | undefined)[]
  icon?: React.ReactNode
  justifyIcon?: React.CSSProperties['justifyContent']
}

export default function NodeData({ icon, data, justifyIcon, ...props }: Props) {
  return (
    <Stack
      direction="row"
      {...props}
      sx={[{
        marginY: 2,
        width: '100%',
        gap: 1
      }, ...(Array.isArray(props.sx) ? props.sx : [props.sx])]}>
      <Stack
        sx={{
          color: 'contrast.medium',
          width: 26,
          flexShrink: 0,
          justifyContent: justifyIcon
        }}>
        {icon}
      </Stack>
      <Box
        sx={{
          flex: 1,
          wordBreak: 'break-word'
        }}>
        {data.map(
          (item, index) =>
            item?.[0] && (
              <Typography key={index} variant="body2" color="textSecondary" component="div">
                {item[0]}{' '}
                <Box component="span" sx={{
                  color: 'contrast.max'
                }}>
                  {item[1]}
                </Box>
              </Typography>
            )
        )}
      </Box>
    </Stack>
  )
}
